module.exports = __webpack_public_path__ + "img/User.fa881ddb.svg";